var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndoorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 28,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7646484,14.2927246l-1.3173828-2.6345215C21.9355469,10.6357422,20.9072266,10,19.7636719,10h-7.5273438 c-1.1435547,0-2.171875,0.6357422-2.6835938,1.6582031l-1.3173828,2.6345215C6.8522949,15.126709,6,16.6008301,6,18.2363281 l0.0048828,8.046875C6.0048828,27.2460938,6.8828125,28,8.0029297,28h1.9980469C11.1220703,28,12,27.2460938,12,26.2832031V24h8 v2.2832031C20,27.2460938,20.8789062,28,22,28h2c1.1210938,0,2-0.7539062,2-1.7167969v-8.046875 C26,16.6008301,25.1477051,15.126709,23.7646484,14.2927246z M11.3417969,12.5527344 C11.5117188,12.2119141,11.8544922,12,12.2363281,12h7.5273438c0.3818359,0,0.7246094,0.2119141,0.8945312,0.5527344L21.3818359,14 H10.6181641L11.3417969,12.5527344z M10,26H8.0048828v-2H10V26z M24,26h-2v-2h2V26z M24,22H8.0048828L8,20.0146484h4v-2H8.0285645 C8.0996094,17.1809082,8.5407715,16.4345703,9.2558594,16h13.4882812c0.7150879,0.4345703,1.1563721,1.1809082,1.2272949,2.0146484 H20v2h4V22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorSmall);
export default __webpack_public_path__ + "static/media/indoor--small.8f5144c4451f848ec104c8cf69afba08.svg";
export { ForwardRef as ReactComponent };